let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4Dwf2")).then(() => parcelRequire('i2rQL'));